import { createAsyncThunk } from '@reduxjs/toolkit';
import { ProductRNQueryDto } from './api.dto';
import { ServiceLibs } from '@services/ServiceLibs';

export const getCountReviews = createAsyncThunk<number, ProductRNQueryDto, any>('product/getCountReviews', async query => {
  return await ServiceLibs.getReviewsWidget(query.productRN);
});
